import { atom } from 'recoil';

import { Toast } from '@/types/Toast';

export const toastState = atom<Array<Toast>>({
  key: 'toastState',
  default: [],
});
